import { z } from 'zod';
import type { HttpClient } from './http';

export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  db: z.boolean(),
  timestamp: z.string().datetime({ offset: true }),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;

export class HealthResource {
  constructor(private readonly http: HttpClient) {}

  check(signal?: AbortSignal): Promise<HealthResponse> {
    return this.http.request({
      method: 'GET',
      path: '/healthz',
      responseSchema: healthResponseSchema,
      signal,
    });
  }
}
